export { default } from './Typography';



// WEBPACK FOOTER //
// ./src/design-system/atoms/Typography/index.jsx